import {
  dbui_v1_Query_GenerateRequest,
  dbuiV1QueryGenerateMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';

export const useCreateQuery = () => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id;

  return useMutation({
    mutationFn: (data: Omit<dbui_v1_Query_GenerateRequest, 'warehouse'>) =>
      dbuiV1QueryGenerateMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: { ...data, warehouse }, path: { workspace } }),
  });
};
